import React, { useEffect, useState } from 'react';
import MapeamentoDetails from '../../components/mapeamentos/MapeamentoDetails';
import NotaEntradaView from '../../components/mapeamentos/NotaEntradaView';
import NotasEntradaList from '../../components/mapeamentos/NotasEntradaList';
import notaEntradaMapeamentosApi from '../../services/api/notaEntradaMapeamentosApi';
import './Mapeamentos.css';

// view: 'notas' | 'nota' | 'mapeamento'
const Mapeamentos = () => {
  const [view, setView] = useState('notas');
  const [notas, setNotas] = useState([]);
  const [selectedNota, setSelectedNota] = useState(null);
  const [selectedMapeamento, setSelectedMapeamento] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadNotas();
  }, []);

  const loadNotas = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await notaEntradaMapeamentosApi.listNotasEntrada(100, 0);
      setNotas(response.items || []);
    } catch (err) {
      console.error('Erro ao carregar notas de entrada:', err);
      setError('Erro ao carregar lista de notas de entrada');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectNota = (nota) => {
    setSelectedNota(nota);
    setSelectedMapeamento(null);
    setView('nota');
  };

  const handleSelectMapeamento = async (mapeamento) => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await notaEntradaMapeamentosApi.getMapeamentoById(mapeamento.id);
      setSelectedMapeamento(data);
      setView('mapeamento');
    } catch (err) {
      console.error('Erro ao carregar detalhes do mapeamento:', err);
      setError(`Erro ao carregar detalhes: ${err.message || 'Erro desconhecido'}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToNotas = () => {
    setSelectedNota(null);
    setSelectedMapeamento(null);
    setView('notas');
  };

  const handleBackToNota = () => {
    setSelectedMapeamento(null);
    setView('nota');
  };

  const renderMainContent = () => {
    if (isLoading) {
      return (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Carregando...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-state">
          <div className="error-icon">⚠️</div>
          <h3>Erro</h3>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={view === 'notas' ? loadNotas : handleBackToNota}>
            Tentar Novamente
          </button>
        </div>
      );
    }

    if (view === 'mapeamento' && selectedMapeamento) {
      return (
        <MapeamentoDetails
          mapeamento={selectedMapeamento}
          onBack={handleBackToNota}
          onRefresh={async () => {
            const data = await notaEntradaMapeamentosApi.getMapeamentoById(selectedMapeamento.id);
            setSelectedMapeamento(data);
          }}
        />
      );
    }

    if (view === 'nota' && selectedNota) {
      return (
        <NotaEntradaView
          nota={selectedNota}
          onSelectMapeamento={handleSelectMapeamento}
          onBack={handleBackToNotas}
        />
      );
    }

    return (
      <div className="no-data">
        <div className="no-data-icon">📄</div>
        <p>Selecione uma nota de entrada</p>
        <span>Clique em uma nota na lista ao lado para ver o histórico de mapeamentos</span>
      </div>
    );
  };

  return (
    <div className="mapeamentos-page">
      <div className="mapeamentos-sidebar">
        <div className="sidebar-header">
          <h2>Notas de Entrada</h2>
          <p>Selecione uma nota para ver os mapeamentos</p>
        </div>
        <div className="sidebar-content">
          <NotasEntradaList
            notas={notas}
            selectedNota={selectedNota}
            onSelectNota={handleSelectNota}
            isLoading={isLoading && view === 'notas'}
          />
        </div>
      </div>

      <div className="mapeamentos-main-content">
        {renderMainContent()}
      </div>
    </div>
  );
};

export default Mapeamentos;
